import * as types from '@/store/types';
import { removeNamespaces } from '@/helpers/utils';

const localTypes = removeNamespaces(types);

export default {
  [localTypes.BANNERS_TRIGGER](state) {
    return state.bannersTrigger;
  },
};
